import React, { Component } from 'react'
import { cashRegisterInfoArray } from './cashRegisterInfo'

class CashRegister extends Component {
  render() {
    return (
    <li>
      <select style={{fontSize: '1.3rem'}} value={this.props.register} onChange={this.props.handleRegisterSelect}>
        {cashRegisterInfoArray.map(register => {
          return <option key={register.value} value={register.value}>{register.name}</option>
        })}
      </select>
    </li>
    )
  }
}

export default CashRegister


// WEBPACK FOOTER //
// ./src/components/ofdCalc/cashRegister/CashRegister.js